import React from 'react'
import InputField from '../../../components/inputField/InputField';

import Button from '../../../components/button/Button';
import { MailIcon } from '../../../icons';

const QouteSection = () => {
    return (
        <div className='flex items-center justify-between max-lg:flex-col max-w-[1980px] w-full max-sm:text-center'>
            <div className="relative w-full py-[20vh] px-[7.2vw] flex flex-col gap-[32px] h-full">
                <div className="flex flex-col gap-[12px] lg:max-w-[420px]">
                    <h2 className='text-[36px] font-bold text-[#101828]'>
                        Advance Your Expertise: Register for Our Master Class
                    </h2>
                    <span className='text-[#475467]'>
                        Cultivating Mastery: A Journey Beyond the Basics
                    </span>
                </div>
                <div className="flex flex-col gap-[24px]">
                    <div className="flex flex-col gap-[20px]">
                        <InputField label={'Name*'} placeholder={'Enter your name'} />
                        <InputField label={'Email*'} placeholder={'Enter your name'} />
                    </div>
                    <Button children={'Send '} className={'!text-[16px] !px-[16px] !py-[10px] text-center'} />
                </div>
            </div>
            <div className="flex items-center justify-center w-full">
                <img src="/images/register.png" alt="" />
            </div>
        </div>
    )
}

export default QouteSection;